import { useState, useEffect } from 'react';
import { DataTable } from '../../../components/table/table.tsx';
import { apiUrl } from "../../../config/config.js";
import { Container, Spinner } from 'react-bootstrap';
import EventDetailModal from '../events/eventDetail';
import Swal from 'sweetalert2';
import { Card } from "../../../components/card/card.jsx";

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

export default function EventsScreen() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${apiUrl}/events`);
            const data = await res.json();
            if (data.ok) {
                setEvents(data.events || []);
            } else {
                Toast.fire({
                    icon: 'error',
                    title: 'Error al cargar eventos'
                });
            }
        } catch (error) {
            console.error('Error fetching events:', error);
            Toast.fire({
                icon: 'error',
                title: 'Error de conexión'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (event) => {
        setSelectedEvent(event);
        setShowModal(true);
    };

    const handleDelete = async (event) => {
        const userEmail = JSON.parse(window.localStorage.getItem("userProfile")).email;

        const confirm = await Swal.fire({
            title: '¿Eliminar evento?',
            text: `¿Estás seguro de eliminar "${event.titleEvent}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (confirm.isConfirmed) {
            try {
                const res = await fetch(`${apiUrl}/events/${event.idEvent}`, {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ deletedBy: userEmail })
                });

                const data = await res.json();

                if (data.ok) {
                    Toast.fire({
                        icon: 'success',
                        title: 'Evento eliminado correctamente'
                    });
                    fetchEvents();
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'Error al eliminar evento'
                    });
                }
            } catch (error) {
                console.error('Error deleting event:', error);
                Toast.fire({
                    icon: 'error',
                    title: 'Error de conexión'
                });
            }
        }
    };

    const handleCreate = () => {
        setSelectedEvent(null);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedEvent(null);
    };

    const columns = [
        {
            key: 'titleEvent',
            label: 'Título del Evento',
        },
        {
            key: 'yearEvent',
            label: 'Año',
        },
        {
            key: 'dates',
            label: 'Fechas',
            render: (dates) => {
                if (!dates || dates.length === 0) return 'Sin fechas';
                return `${dates.length} fecha(s)`;
            }
        },
        {
            key: 'status',
            label: 'Estado',
            render: (status) => {
                const statusMap = {
                    'ACTIVE': { text: 'Activo', class: 'badge bg-success' },
                    'DELETED': { text: 'Eliminado', class: 'badge bg-danger' }
                };
                const statusInfo = statusMap[status] || { text: status, class: 'badge bg-secondary' };
                return <span className={statusInfo.class}>{statusInfo.text}</span>;
            }
        }
    ];

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Cargando eventos...</p>
            </Container>
        );
    }

    return (
        <Container fluid className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="mb-0">Gestión de Eventos</h2>
                <button onClick={handleCreate} className="btn btn-outline-theme">
                    <i className="fa fa-plus-circle fa-fw me-1"></i> Nuevo Evento
                </button>
            </div>

            <Card>
                <div className="tab-content p-4">
                    <div className="tab-pane fade show active" id="allTab">
                        <DataTable
                            data={events}
                            columns={columns}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                            hiddenFields={['idEvent', 'createdAt', 'createdBy', 'updatedAt', 'updatedBy']}
                        />
                    </div>
                </div>
            </Card>
            <EventDetailModal
                show={showModal}
                onClose={handleCloseModal}
                eventSelected={selectedEvent}
                fetchData={fetchEvents}
            />
        </Container>
    );
}